var _path, _g, _path2, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 199,
    viewBox: "0 0 1000 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.6060606060606233,-0.0033384775849896187)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 79",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 199,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,0.0013253252724325648)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 78.9973493494551",
    height: 78.9973493494551,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 520.7082730105041 104.0012473507338",
    height: 78.9973493494551,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,125.18827301050406,29.563965925563608)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 44.87331549960659",
    height: 44.87331549960659,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 44.87331549960659",
    height: 44.87331549960659,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 44.87331549960659",
    height: 44.87331549960659,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "4.35 -35.65 317.71999999999997 36.05",
    height: 44.87331549960659,
    "data-palette-color": "#0080ff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 0L4.35 0 4.35-35.25 8.45-35.25 8.45-3.5 26.1-3.5 26.1 0ZM53.65 0L31.35 0 31.35-35.25 53.65-35.25 53.65-31.85 35.4-31.85 35.4-19.6 52.65-19.6 52.65-16.2 35.4-16.2 35.4-3.4 53.65-3.4 53.65 0ZM72.5 0L68.34 0 68.34-31.75 56.09-31.75 56.09-35.25 84.8-35.25 84.8-31.75 72.5-31.75 72.5 0ZM92.29-21.4L89.59-21.4 88.49-35.25 93.29-35.25 92.29-21.4ZM123.09 0L100.79 0 100.79-35.25 123.09-35.25 123.09-31.85 104.84-31.85 104.84-19.6 122.09-19.6 122.09-16.2 104.84-16.2 104.84-3.4 123.09-3.4 123.09 0ZM146.64-9.7L159.84-35.25 163.19-35.25 163.19 0 159.44 0 159.49-27.3 148.04-5.6 145.14-5.6 133.64-27.1 133.69 0 129.89 0 129.89-35.25 133.29-35.25 146.64-9.7ZM199.88 0.4Q194.88 0.4 191.18-1.78 187.48-3.95 185.51-8.03 183.53-12.1 183.53-17.65L183.53-17.65Q183.53-23.2 185.51-27.25 187.48-31.3 191.18-33.48 194.88-35.65 199.88-35.65L199.88-35.65Q203.53-35.65 206.58-34.52 209.63-33.4 211.88-31.2L211.88-31.2 210.33-28.05Q207.78-30.2 205.33-31.15 202.88-32.1 199.93-32.1L199.93-32.1Q194.13-32.1 190.96-28.33 187.78-24.55 187.78-17.65L187.78-17.65Q187.78-10.7 190.96-6.93 194.13-3.15 199.93-3.15L199.93-3.15Q202.88-3.15 205.33-4.1 207.78-5.05 210.33-7.2L210.33-7.2 211.88-4.05Q209.63-1.85 206.58-0.73 203.53 0.4 199.88 0.4L199.88 0.4ZM232.88 0.4Q227.98 0.4 224.35-1.8 220.73-4 218.78-8.05 216.83-12.1 216.83-17.6L216.83-17.6Q216.83-23.15 218.75-27.23 220.68-31.3 224.31-33.48 227.93-35.65 232.88-35.65L232.88-35.65Q237.83-35.65 241.46-33.48 245.08-31.3 247-27.23 248.93-23.15 248.93-17.65L248.93-17.65Q248.93-12.15 246.98-8.08 245.03-4 241.41-1.8 237.78 0.4 232.88 0.4L232.88 0.4ZM232.88-3.1Q238.48-3.1 241.61-6.88 244.73-10.65 244.73-17.65L244.73-17.65Q244.73-24.65 241.63-28.4 238.53-32.15 232.88-32.15L232.88-32.15Q227.28-32.15 224.16-28.38 221.03-24.6 221.03-17.65L221.03-17.65Q221.03-10.7 224.16-6.9 227.28-3.1 232.88-3.1L232.88-3.1ZM271.08 0.4Q266.18 0.4 262.55-1.8 258.93-4 256.98-8.05 255.03-12.1 255.03-17.6L255.03-17.6Q255.03-23.15 256.95-27.23 258.88-31.3 262.5-33.48 266.13-35.65 271.08-35.65L271.08-35.65Q276.03-35.65 279.65-33.48 283.28-31.3 285.2-27.23 287.13-23.15 287.13-17.65L287.13-17.65Q287.13-12.15 285.18-8.08 283.23-4 279.6-1.8 275.98 0.4 271.08 0.4L271.08 0.4ZM271.08-3.1Q276.68-3.1 279.8-6.88 282.93-10.65 282.93-17.65L282.93-17.65Q282.93-24.65 279.83-28.4 276.73-32.15 271.08-32.15L271.08-32.15Q265.48-32.15 262.35-28.38 259.23-24.6 259.23-17.65L259.23-17.65Q259.23-10.7 262.35-6.9 265.48-3.1 271.08-3.1L271.08-3.1ZM302.73-18.1L322.07 0 316.78 0 298.63-16.75 298.63 0 294.53 0 294.53-35.25 298.63-35.25 298.63-19.05 315.93-35.25 321.13-35.25 302.73-18.1Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#0080ff",
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104.0012473507338 104.0012473507338",
    height: 104.0012473507338,
    width: 104.0012473507338,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", {
    id: "icon-0"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104.0012473507338 104.0012473507338",
    height: 104.0012473507338,
    width: 104.0012473507338,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 52.001c0-28.719 23.281-52.001 52.001-52.001 28.719 0 52.001 23.281 52 52.001 0 28.719-23.281 52.001-52 52-28.719 0-52.001-23.281-52.001-52zM52.001 99.955c26.484 0 47.954-21.47 47.954-47.954 0-26.484-21.47-47.954-47.954-47.954-26.484 0-47.954 21.47-47.954 47.954 0 26.484 21.47 47.954 47.954 47.954z",
    "data-fill-palette-color": "accent",
    fill: "#010c80",
    stroke: "transparent"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,32.07930622929234,26.734048155902364)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39.84263489214912 50.53315103892908",
    height: 50.53315103892908,
    width: 39.84263489214912,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "29.464683125250218 13.44113970411635 138.07088668364054 175.11786029588364",
    enableBackground: "new 0 0 197 202",
    xmlSpace: "preserve",
    height: 50.53315103892908,
    width: 39.84263489214912,
    className: "icon-kj-0",
    "data-fill-palette-color": "accent",
    id: "kj-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.863 13.788c-1.523-0.785-3.397-0.193-4.185 1.326l-21.223 40.854H32.571c-1.281 0-2.43 0.787-2.894 1.982-0.465 1.191-0.151 2.545 0.793 3.41l11.597 10.654c0.171 0.152 0.379 0.244 0.573 0.357v100.379c0 8.717 7.092 15.809 15.806 15.809h72.631c8.714 0 15.803-7.092 15.803-15.809V73.142c0-0.105-0.019-0.205-0.033-0.311h1.55c4.65 0 8.429-3.781 8.429-8.428 0-4.654-3.778-8.436-8.429-8.436h-0.947l19.733-37.992C167.978 16.454 167.382 14.581 165.863 13.788zM45.378 66.626l-4.841-4.449h96.7l-2.311 4.449H45.378zM77.764 150.026c-9.343-10.955-12.242 6.445-17.074 11.279-2.647 2.479-7.159 2.838-11.839 2.592v-18.021h10.96c1.713 0 3.104-1.393 3.104-3.104 0-1.713-1.391-3.107-3.104-3.107h-10.96V131.8h25.448c1.718 0 3.104-1.395 3.104-3.105 0-1.715-1.386-3.107-3.104-3.107H48.851v-7.865h10.96c1.713 0 3.104-1.389 3.104-3.104s-1.391-3.105-3.104-3.105h-10.96v-7.865h25.448c1.718 0 3.104-1.389 3.104-3.107 0-1.707-1.386-3.104-3.104-3.104H48.851v-7.867h10.96c1.713 0 3.104-1.391 3.104-3.107 0-1.713-1.391-3.102-3.104-3.102h-10.96V72.827h82.852l-45.351 87.32C81.999 157.931 80.874 153.983 77.764 150.026zM140.677 73.142v80.885c-1.743 1.15-3.614 2.176-5.885 2.766-5.153 1.289-11.276-1.932-16.107-3.867-4.188-1.613-6.766-3.219-10.634 0-2.579 2.578-2.898 7.086-6.444 9.021-2.2 1.096-6.028 0.838-9.273 0.156l46.365-89.273h2.008C140.697 72.933 140.677 73.034 140.677 73.142zM148.4 62.177c1.224 0 2.221 0.998 2.221 2.227 0 1.225-0.997 2.221-2.221 2.221h-6.48l2.311-4.447H148.4z",
    fill: "#010c80",
    "data-fill-palette-color": "accent"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 78.9973493494551,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoBackground);
export default __webpack_public_path__ + "static/media/logo-no-background.2a019fdc6f325bed99ea5c572805c130.svg";
export { ForwardRef as ReactComponent };